import { useState, useEffect, useContext, useRef, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { firestore, storage, auth, serverTimestamp } from '../lib/firebase';
import Navbar from '../components/NavbarDashboard';
import NavbarMobile from '../components/NavbarDashboardMobile';
import styles from '../styles/Dashboard.module.css';
import styles2 from '../styles/Birth.module.css';
import { UserContext } from '../lib/context';
import Webcam from 'react-webcam';
import toast from 'react-hot-toast';
import NumberFormat from 'react-number-format';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Profile() {
  return (
    <>
      <Navbar />
      <Body />
    </>
  );
}

function Body() {
  const [isLoading, setIsLoading] = useState(false);
  const [photoID, setPhotoID] = useState(null);
  const [modal, setModal] = useState(false);
  const { user, userData } = useContext(UserContext);
  // State Loaded
  const [userLoaded, setUserLoaded] = useState(false);
  const [userDataLoaded, setUserDataLoaded] = useState(false);
  const [stateLoaded, setStateLoaded] = useState(false);

  // Loaded - User
  useEffect(() => {
    // console.log(user?.uid);
    if (user) {
      setUserLoaded(true);
    }
  }, [user]);

  // Loaded - UserData
  useEffect(() => {
    // console.log(userData);
    if (userData?.urlID) {
      setPhotoID(userData?.urlID);
    }
    if (userData) {
      setUserDataLoaded(true);
      setValue('firstName', userData?.firstName);
      setValue('lastName', userData?.lastName);
      setValue('phoneNumber', userData?.phoneNumber);
      setValue('dateOfBirth', userData?.dateOfBirth);
    }
  }, [userData]);

  useEffect(() => {
    if (userLoaded && userDataLoaded) {
      setStateLoaded(true);
    }
  }, [userLoaded]);

  useEffect(() => {
    if (userLoaded && userDataLoaded) {
      setStateLoaded(true);
    }
  }, [userDataLoaded]);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setError,
    clearErrors,
    setValue,
    control,
    formState: { errors },
  } = useForm({ mode: 'onBlur', reValidateMode: 'onChange' });

  const sendForm = async (data) => {
    console.log(data);
    setIsLoading(true);

    // Firebase Code
    try {
      const userSnapshot = await firestore
        .collection('users')
        .doc(user?.uid)
        .get();

      let insertData = {
        ...data,
      };

      // Update existing user
      await userSnapshot.ref.update(insertData);
      toast.success('Profile saved.');
    } catch (e) {
      // send to backend
    }

    setIsLoading(false);
  };

  const photoClick = () => {
    setModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModal(false);
    document.body.style.overflow = 'scroll';
  };

  return (
    <>
      {modal && <Modal closeModal={closeModal} user={user} />}
      <div className={`${styles['dashboard-container']} red`}>
        <div className={`${styles['dashboard-container-max']} red`}>
          <div className={`${styles['profile-item-container']} red`}>
            <form onSubmit={handleSubmit(sendForm)}>
              {/* INPUT */}
              {/* INPUT */}
              {/* INPUT */}
              <div className={`${styles['input-height-container']} red`}>
                <div className={`${styles['w50']} red`}>
                  <div className={`${styles['input-label']} red`}>
                    {stateLoaded ? 'First name' : <Skeleton />}
                  </div>
                  {stateLoaded ? (
                    <input
                      className={`${styles['input-text']} red`}
                      autoComplete="off"
                      placeholder="First"
                      {...register('firstName', {
                        required: true,
                      })}
                    />
                  ) : (
                    <Skeleton height={55} />
                  )}

                  {errors.firstName?.type === 'required' && (
                    <div className={`${styles['input-error']} red`}>
                      First name required
                    </div>
                  )}
                </div>
                <div className={`${styles['input-space-flex']} red`} />
                <div className={`${styles['w50']} red`}>
                  <div className={`${styles['input-label']} red`}>
                    {stateLoaded ? 'Last name' : <Skeleton />}
                  </div>
                  {stateLoaded ? (
                    <input
                      className={`${styles['input-text']} red`}
                      autoComplete="off"
                      placeholder="Last"
                      {...register('lastName', {
                        required: true,
                      })}
                    />
                  ) : (
                    <Skeleton height={55} />
                  )}

                  {errors.lastName?.type === 'required' && (
                    <div className={`${styles['input-error']} red`}>
                      Last name required
                    </div>
                  )}
                </div>
              </div>

              <div className={`${styles['input-space']} red`} />

              {/* INPUT */}
              {/* INPUT */}
              {/* INPUT */}
              <div className={`${styles['w100']} red`}>
                <div className={`${styles['input-label']} red`}>
                  {stateLoaded ? 'Birthday (dd/mm/yyyy)' : <Skeleton />}
                </div>
                {stateLoaded ? (
                  <Controller
                    control={control}
                    name="dateOfBirth"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, onBlur, ref, name, value },
                    }) => (
                      <NumberFormat
                        className={`${styles['input-text-phone']} red`}
                        format="##/##/####"
                        placeholder="22/03/1998"
                        name={name}
                        ref={ref}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                      />
                    )}
                  />
                ) : (
                  <Skeleton height={55} />
                )}

                {errors.dateOfBirth?.type === 'required' && (
                  <div className={`${styles['input-error']} red`}>
                    Birthday required
                  </div>
                )}
              </div>
              <div className={`${styles['input-space']} red`} />

              {/* INPUT */}
              {/* INPUT */}
              {/* INPUT */}
              <div className={`${styles['w100']} red`}>
                <div className={`${styles['input-label']} red`}>
                  {stateLoaded ? 'Phone number' : <Skeleton />}
                </div>
                {stateLoaded ? (
                  <Controller
                    control={control}
                    name="phoneNumber"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, onBlur, ref, name, value },
                    }) => (
                      <NumberFormat
                        className={`${styles['input-text-phone']} red`}
                        format="(###) ###-####"
                        placeholder="(647) 123-4567"
                        name={name}
                        ref={ref}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                      />
                    )}
                  />
                ) : (
                  <Skeleton height={55} />
                )}

                {errors.phoneNumber?.type === 'required' && (
                  <div className={`${styles['input-error']} red`}>
                    Phone number required
                  </div>
                )}
              </div>
              <div className={`${styles['input-space']} red`} />
              <div className={`${styles['input-space']} red`} />

              {/* PHOTO ID */}
              {/* PHOTO ID */}
              {/* PHOTO ID */}
              <div className={`${styles['w100']} red`}>
                <div className={`${styles['input-label']} red`}>
                  {stateLoaded ? 'Photo ID' : <Skeleton />}
                </div>
                <div className={`${styles['photo-frame2']} red`}>
                  {stateLoaded ? (
                    <img
                      className={`${styles['image-upload']} red`}
                      src={photoID}
                    />
                  ) : (
                    <Skeleton height={280} width={400} />
                  )}
                </div>
                <div
                  className={`${styles['photo-btn-text']} red`}
                  onClick={photoClick}
                >
                  Upload new ID
                </div>
              </div>

              <button
                className={`${styles['save-changes-btn']} red`}
                type="submit"
                disabled={isLoading}
              >
                Save changes
              </button>
            </form>
          </div>
          <NavbarMobile />
        </div>
      </div>
    </>
  );
}

// ----------
// COMPONENTS
// ----------

// Modal
function Modal({ closeModal, user }) {
  const [mode, setMode] = useState(null);
  const [uploading, setUploading] = useState(false);
  const webcamRef = useRef(null);
  const sizeRef = useRef(null);
  const [imgFile, setImgFile] = useState(null); // File mode --- img in jpeg or original format
  const [imgFileBase64, setImgFileBase64] = useState(null); // File mode --- img in base64 format
  const [imgWebcamBase64, setImgWebcamBase64] = useState(null); // Webcam mode --- picture taken in base64 format

  // useEffect(() => {
  //   console.log(sizeRef.current);
  // }, [sizeRef]);

  const updateUrlID = async (urlID) => {
    // console.log(urlID);
    setUploading(true);
    try {
      const userSnapshot = await firestore
        .collection('users')
        .doc(user?.uid)
        .get();
      await userSnapshot.ref.update({ ...urlID, urlIDAt: serverTimestamp() });
    } catch (e) {
      console.log(e);
    }

    setUploading(false);
    closeModal();
  };

  // Utility function
  async function dataUrlToFile(dataUrl, fileName) {
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], fileName, { type: 'image/jpeg' });
  }

  // Utility function
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  // File Mode -- click on upload a picture area -- process picture and upload in front-end memory
  const processFile = async (e) => {
    // Get the file
    const file = Array.from(e.target.files)[0];
    if (file) {
      const basefile = await toBase64(file);
      setImgFileBase64(basefile); // File mode --- img in base64 format
      setImgFile(file); // File mode --- img in jpeg or original format
    }
  };

  // File Mode -- click on continue button -- upload the picture to firebase
  const uploadFile = async (file) => {
    try {
      const fileSize = file.size / 1024 / 1024;
      if (fileSize <= 5) {
        const extension = file.type.split('/')[1];
        // Makes reference to the storage bucket location
        setUploading(true);
        const ref = storage.ref(
          `uploads/${auth.currentUser.uid}/id/${Date.now()}.${extension}`
        );

        // Starts the upload
        const task = ref.put(file);
        // Get downloadURL AFTER task resolves (Note: this is not a native Promise)
        task
          .then((d) => ref.getDownloadURL())
          .then((url) => {
            console.log(url);
            // -------
            updateUrlID({ urlID: url });
            setUploading(false);
            // -------
          });
      } else {
        alert('File size exceeds 5MB');
      }
    } catch (e) {
      // do something
    }
  };

  // In webcam mode, captures a webcam screenshot
  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgWebcamBase64(imageSrc);
  }, [webcamRef, setImgWebcamBase64]);

  // In webcam mode, remove the taken picture
  const retake = () => {
    setImgWebcamBase64(null);
  };

  // In webcam mode, upload the picture that was taken to Firebase storage
  const uploadWebcam = async () => {
    try {
      const file = await dataUrlToFile(imgWebcamBase64, Date.now());
      const fileSize = file.size / 1024 / 1024;
      if (fileSize <= 5) {
        // Makes reference to the storage bucket location
        setUploading(true);
        const ref = storage.ref(
          `uploads/${auth.currentUser.uid}/id/${Date.now()}.jpeg`
        );

        // Starts the upload
        const task = ref.put(file);

        // Get downloadURL AFTER task resolves (Note: this is not a native Promise)
        task
          .then((d) => ref.getDownloadURL())
          .then((url) => {
            // ----
            updateUrlID({ urlID: url });
            setUploading(false);
            // ----
          });
      } else {
        alert('File size exceeds 5MB');
      }
    } catch (e) {}
  };

  return (
    <div className={`${styles['modal-backdrop']} red`} onClick={closeModal}>
      <div
        className={`${styles['modal-container2']} red`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`${styles['modal-title']} red`}>
          Upload your government ID
        </div>

        {mode == 'webcam' && (
          <div className={`${styles2['image-upload-group']} red`}>
            {/* Driver license */}

            <img
              className={`${styles2['image-upload-driver2']} red`}
              src="/landing/drivers-on.png"
            />

            {/* Health Card */}
          </div>
        )}

        {/* SELECT MODE */}
        {/* SELECT MODE */}
        {/* SELECT MODE */}
        {!mode && (
          <>
            <button
              className={`${styles['menu-btn2']} red`}
              onClick={() => setMode('file')}
            >
              Upload ID from your device
            </button>
            <div className={`${styles['input-space-16']} red`} />
            <button
              className={`${styles['menu-btn2']} red`}
              onClick={() => setMode('webcam')}
            >
              Upload ID using a camera
            </button>
          </>
        )}

        {/* FILE MODE */}
        {/* FILE MODE */}
        {/* FILE MODE */}

        {!uploading && (
          <input
            className={`${styles['input-hidden']} red`}
            type="file"
            id="fileInput"
            onChange={processFile}
            accept="image/*, .heic, .HEIC, .pdf, .PDF"
          />
        )}
        {mode == 'file' && (
          <>
            <div
              onClick={() => document.getElementById('fileInput').click()}
              className={`${styles['test-upload-btn2']} red`}
            >
              <div className={`${styles['test-upload-btn-text']} red`}>
                {!imgFileBase64 ? (
                  <div className={`${styles2['image-upload-text']} red`}>
                    Click to upload a file
                  </div>
                ) : null}
                {/* Driver license */}
                {!imgFileBase64 && (
                  <img
                    className={`${styles2['image-upload-driver']} red`}
                    src="/landing/drivers-on.png"
                  />
                )}
                {imgFileBase64 && (
                  <>
                    <img
                      className={`${styles['image-upload']} red`}
                      src={imgFileBase64}
                      ref={sizeRef}
                    />

                    {uploading && (
                      <div
                        className={`${styles['vid-black2']} red`}
                        style={{
                          height: sizeRef.current.height,
                          width: sizeRef.current.width,
                          top: 0,
                        }}
                      >
                        <Loader />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className={`${styles['test-sub-container']} red`}>
              <div className={`${styles['test-sub']} red`}>
                We accept driver&apos;s license, passport, and health card as
                long as they have a photo. All your data is safely encrypted.
              </div>
              <div
                className={`${styles['test-switch']} red`}
                onClick={() => setMode('webcam')}
              >
                Switch to webcam mode
              </div>
            </div>
            {/* Upload Button */}
            <button
              onClick={() => uploadFile(imgFile)}
              disabled={uploading || !imgFileBase64}
              className={`${styles['take-photo-btn']} red`}
            >
              Upload
            </button>
          </>
        )}

        {/* WEBCAM MODE */}
        {/* WEBCAM MODE */}
        {/* WEBCAM MODE */}

        {mode == 'webcam' && (
          <>
            <WebcamCapture
              imgWebcamBase64={imgWebcamBase64}
              webcamRef={webcamRef}
              uploading={uploading}
            />
            <div className={`${styles['test-sub-container']} red`}>
              <div className={`${styles['test-sub']} red`}>
                We accept driver&apos;s license, passport, and health card as
                long as they have a photo. All your data is safely encrypted.
              </div>
              <div
                className={`${styles['test-switch']} red`}
                onClick={() => setMode('file')}
              >
                Switch to file mode
              </div>
            </div>

            {/* Navigation Buttons ------ Webcam mode*/}
            <div className={`${styles['nav-buttons-bottom']} red`}>
              {!imgWebcamBase64 && (
                <button
                  className={`${styles['take-photo-btn']} red`}
                  onClick={capture}
                >
                  Take photo
                </button>
              )}

              {imgWebcamBase64 && (
                <>
                  <button
                    className={`${styles['take-photo-btn']} red`}
                    onClick={retake}
                    disabled={uploading}
                  >
                    Retake photo
                  </button>
                  <div className={`${styles['take-photo-btn-space']} red`} />

                  <button
                    onClick={uploadWebcam}
                    disabled={uploading}
                    className={`${styles['take-photo-btn']} red`}
                  >
                    Continue
                  </button>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function Loader() {
  return (
    <div className={`${styles['lds-ring']} red`}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

const WebcamCapture = ({ imgWebcamBase64, webcamRef, uploading }) => {
  const videoConstraints = {
    width: 450,
    height: 300,
  };

  return (
    <>
      <div className={`${styles['vid-wrapper']} red`}>
        {imgWebcamBase64 ? (
          <>
            <img src={imgWebcamBase64} />
            {uploading && (
              <div className={`${styles['vid-black']} red`}>
                <Loader />
              </div>
            )}
          </>
        ) : (
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
          />
        )}
      </div>
    </>
  );
};
